<template>
  <div>
    <SearchComponent
      :isAdd="true"
      :selectOrInputList="selectOrInputList"
      @on-search="handleSearch"
      @on-reset="handleReset"
      @on-add="add"
      :authIdentity="authIdentity"
    ></SearchComponent>
    <TablePublic
      :colLists="colLists"
      :tableData="tableData"
      :total="total"
      @pageChange="handleSearch"
    >
      <!-- <template slot="status" slot-scope="scope">
        <div class="center">
          <span v-if="scope.data.status == 0" class="normal">正常</span>
          <span v-else class="disable">停用</span>
        </div>
      </template>-->
      <template slot="createTime" slot-scope="scope">
        <span>{{ parseTime(scope.data.createTime, '{y}-{m}-{d}')}}</span>
      </template>
      <template slot="solts" slot-scope="scope">
        <!-- <el-button
          @click="handleSee(scope.data, scope.$index)"
          type="text"
          size="small"
          class="button"
        >详情</el-button>-->
        <el-button
          @click="handleUpdata(scope.data, scope.$index)"
          type="text"
          size="small"
          class="button"
        >修改</el-button>

        <el-button
          class="delbutton"
          type="text"
          size="small"
          @click="handleDel(scope.data, scope.$index)"
        >删除</el-button>
      </template>
    </TablePublic>

    <!-- 弹窗区域 -->
    <Mdialog
      :title="title"
      :visible.sync="dialogVisible"
      width="50%"
      :close-on-click-modal="false"
      :append-to-body="true"
      @closes="cancel"
    >
      <component ref="myform" :is="currentView" :type="type"></component>
      <span slot="footer" v-if="type !='detail'">
        <el-button class="batch-button" @click="cancel">取 消</el-button>
        <el-button class="line-button" @click="submitFrom">确 定</el-button>
      </span>
    </Mdialog>
  </div>
</template>

<script>
import SearchComponent from '@/components/searchComponent'
import Mdialog from '@/components/Mdialog'
import TablePublic from '@/components/tablePublic'
import myform from '@/views/system/role/components/form'
import { getRoleList } from '@/api/system/system'
import { saveRole, detailRole, delrole, updaterole } from '@/api/system/system'
export default {
  components: {
    TablePublic,
    SearchComponent,
    Mdialog,
    myform,
  },
  data() {
    return {
      authIdentity: 'system:role',
      queryParams: {
        pageNo: 1,
        status: '',
        pageSize: 10,
        roleName: '',
      },
      dialogVisible: false,
      title: '',
      currentView: '',
      // operatDialog: {
      //   visible: false, //是否展示
      //   title: '', //弹窗标题
      //   currentView: null, //当前组件
      //   width: '', //弹窗宽度
      //   type: '', //提交类型
      //   data: {}, //弹窗数据
      // },
      colLists: [
        {
          prop: 'roleName',
          label: '角色名称',
          isTrue: true,
        },
        // {
        //   prop: 'roleKey',

        //   label: '权限字符',
        //   isTrue: true,
        // },
        {
          prop: 'createTime',
          label: '创建时间',
          formSolt: true,
          isTrue: true,
        },
        // {
        //   prop: 'status',
        //   label: '状态',
        //   formSolt: true,
        //   isTrue: true,
        // },
        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],
      total: 0,
      type: '',
      tableData: [],
      selectOrInputList: [
        {
          model: 'status',
          placeholder: '请选择状态',
          value: 'value',
          label: 'label',
          list: [
            {
              value: 0,
              label: '正常',
            },
            {
              value: 1,
              label: '停用',
            },
          ],
          type: 'select',
        },
        {
          model: 'roleName',
          placeholder: '请输入角色名称',
          class: 'home',
          type: 'input',
        },
      ],
    }
  },
  created() {
    this.getRoleList(this.queryParams)
  },
  methods: {
    handleDel(row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonClass: 'confirm_button',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(function () {
          return delrole(row.id)
        })
        .then((response) => {
          if (response.flag) {
            this.getRoleList()

            this.$message.success('删除成功')
          } else {
            this.$message.warning(response.data.msg)
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    submitFrom() {
      this.$refs.myform.submit(this.type, (data) => {
        console.log(data)

        if (data) {
          this.$message.success('操作成功')
          this.dialogVisible = false
          this.getRoleList()
        }
      })
    },
    cancel() {
      this.$refs.myform.reset()
      this.dialogVisible = false
    },
    // handleSee() {
    //   this.dialogVisible = true
    //   this.currentView = 'myform'
    //   this.$nextTick(() => {
    //     this.title = '查看角色'

    //     this.type = 'detail'
    //     this.$refs.myform.getData()
    //   })
    // },
    add() {
      this.dialogVisible = true
      this.currentView = 'myform'
      this.$nextTick(() => {
        this.title = '新增角色'

        this.type = 'add'
        this.$refs.myform.getData()
      })
    },
    // handleSee() {
    //   this.dialogVisible = true
    //   this.$nextTick(() => {
    //     this.title = '查看农残检测'
    //     this.currentView = 'Detail'
    //     this.type = 'detail'
    //   })
    // },
    handleUpdata(row) {
      this.dialogVisible = true
      this.currentView = 'myform'
      this.$nextTick(() => {
        this.title = '修改角色'
        this.type = 'edit'
        this.$refs.myform.getListId(row.id)
      })
    },
    handleSearch(data) {
      console.log(data, '----------------------')
      if (data) {
        for (let key in data) {
          this.queryParams[key] = data[key]
        }
      }

      this.getRoleList()
    },
    handleReset() {
      this.queryParams = {
        pageNo: 1,
        status: 0,
        pageSize: 10,
        roleName: '',
      }
      this.getRoleList()
    },
    getRoleList() {
      console.log(this.queryParams, 'this.queryParamsthis.queryParams--------分页')
      getRoleList(this.queryParams)
        .then((res) => {
          console.log(res, 'resresresresresres-----------------')
          if (res.flag) {
            this.tableData = res.data.items
            this.total = res.data.totalCount
            console.log(this.tableData, 'this.tableDatathis.tableData--------------')
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
}
</script>
<style scoped lang='less'>
// @import '../../../../assets/form.less';
.center {
  text-align: center;
}
/deep/ .delbutton.el-button--text {
  color: red;
}
/deep/ .el-button--text {
  font-size: 14px;
}
.disable {
  color: red;
}
.normal {
  color: green;
}
</style>